import React from "react";

function Header() {
    return <div className="heading">
             <h1>Drum 🪘 Kit</h1>
             
            </div>

}

export default Header;